module.exports = __webpack_public_path__ + "img/register-right-1.92fb7dee.svg";